// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"102":"xlsx","884":"admin","932":"import-wizard"}[chunkId] + "." + {"102":"63f51ac5","884":"b5e3404f","932":"e1a96d96"}[chunkId] + ".chunk.js";
};